import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/images/ui/components/common/app-banner/app-image.jpg'
import _imports_1 from '@/images/ui/components/common/app-banner/qr-code.png'
import _imports_2 from '@/images/ui/components/common/app-banner/banner-appstore.png'
import _imports_3 from '@/images/ui/components/common/app-banner/banner-googleplay.png'


import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBanner',
  setup(__props) {

const rootEl = ref<HTMLDivElement>();
const isShow = ref(false);

onMounted(() => {
  if ('IntersectionObserver' in window) {
    const rootElObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isShow.value = true;
          rootElObserver.unobserve(rootEl.value!);
        }
      });
    });
    rootElObserver.observe(rootEl.value!);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl
  }, [
    (isShow.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.wrapper)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.image)
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "iichiの公式アプリ",
              width: "281",
              height: "270",
              loading: "lazy"
            }, null, -1)
          ]), 2),
          _cache[8] || (_cache[8] = _createTextVNode()),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.$style.balloon)
          }, _cache[1] || (_cache[1] = [
            _createTextVNode("アプリ限定", -1),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("span", null, "クーポン配布中！", -1)
          ]), 2),
          _cache[9] || (_cache[9] = _createTextVNode()),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.content)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.text)
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.title)
              }, "iichiの公式アプリ", 2),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.lead)
              }, _cache[2] || (_cache[2] = [
                _createTextVNode("いつでもどこでも、", -1),
                _createElementVNode("br", null, null, -1),
                _createTextVNode("お買い物がもっと便利に。", -1)
              ]), 2)
            ], 2),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.link)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.qr)
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "QRコード",
                  width: "74",
                  height: "74",
                  loading: "lazy"
                }, null, -1)
              ]), 2),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createElementVNode("ul", {
                class: _normalizeClass(_ctx.$style.download)
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "https://apps.apple.com/jp/app/id6639590827?mt=8",
                    target: "_blank"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "App Store からダウンロード",
                      width: "84",
                      height: "31",
                      loading: "lazy"
                    })
                  ])
                ], -1),
                _createTextVNode(),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "https://play.google.com/store/apps/details?id=li.yapp.appFB584294&hl=ja",
                    target: "_blank"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "Google Play で手に入れよう",
                      width: "104",
                      height: "31",
                      loading: "lazy"
                    })
                  ])
                ], -1)
              ]), 2)
            ], 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 512))
}
}

})